module.exports = __webpack_public_path__ + "0af5d249/img/mini-logo.18817ee5.svg";